export const toNumber = (value: string): number => {
  const result = value.replace(/[^\d.]/g, '');
  return result === '' ? 0 : +result;
};
